export default "__VITE_ASSET__f034c05d__"